import styled from "styled-components";

interface TagProps {
  borderColor: string;
  backgroundColor: string;
}

interface SubContainerProps {
  visible?: boolean;
  flexDirection?: string;
  width?: number | string;
}

interface IconBackgroundProps {
  color: string;
  textBackground?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 1rem;
  gap: 30px;
`;

export const ContainerWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 30px;
`;

export const SubContainer = styled.div<SubContainerProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection ?? "row"};
  gap: 15px;
  padding: 16px;
  width: 100%;
  background-color: ${({ theme, visible }) =>
    visible == false ? "transparent" : theme.colors.white};
  border-radius: 3px;

  .titulo {
    font-weight: 600;
    font-size: 16px;
    margin: 0;
  }

  select {
    width: 100%;
    border: none;
  }

  h2 {
    font-weight: bolder;
  }
`;

export const RowDirection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
`;

export const IconBackground = styled.div<IconBackgroundProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 2rem;
  height: 2rem;
  background-color: ${({ color }) => color};
  border-radius: 50px;
  color: #fff;
  font-weight: bolder;

  p {
    margin: 0;
    background-color: ${({ textBackground }) => textBackground};
    border-radius: 50px;
    width: 60%;
  }
`;

export const TituloWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 15px;
  justify-content: space-between;
  white-space: nowrap;
`;

export const Link = styled.a`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;
`;

export const Tag = styled.div<TagProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 50px;
  color: ${({ borderColor }) => borderColor};
  padding: 8px;
`;
